import React from "react";
const PreappChildStatusBar = ({ t }) => {
    return (
        <>
            {t.progression_id === 7 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title="Sent for Signature">Sent for Signature</p>
                </div>
            ) : t.progression_id === 8 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#819FEC" }}
                    />
                    <p title="Pre-Bank Review">Signed</p>
                </div>
            ) : t.progression_id === 9 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#7FCECE" }}
                    />
                    <p title="Underwritting">UW</p>
                </div>
            ) : t.progression_id === 10 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#E7B8DF" }}
                    />
                    <p title="Underwritting pending">UW Pends</p>
                </div>
            ) : t.progression_id === 11 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="Awaiting Reserve">Reserve Req</p>
                </div>
            ) : t.progression_id === 12 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="Approved">Approved</p>
                </div>
            ) : t.progression_id === 13 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#FFA500" }}
                    />
                    <p title="Declined">Declined</p>
                </div>
            ) : t.progression_id === 14 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#660000" }}
                    />
                    <p title="Cancelled">Cancelled</p>
                </div>
            ) : t.progression_id === 15 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="App pending PC approval">
                        App pending PC approval
                    </p>
                </div>
            ) : t.progression_id === 16 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title="Sent for Signature">Sent for Signature</p>
                </div>
            ) : t.progression_id === 17 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title="PDF requested">PDF requested</p>
                </div>
            ) : t.progression_id === 21 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#FF0000" }}
                    />
                    <p title="Terminated">Terminated</p>
                </div>
            ) : t.progression_id === 22 ? (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#0000FF" }}
                    />
                    <p title="Support">Support</p>
                </div>
            ) : (
                <div className="app-circle">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title="Awaiting wet signature">Awaiting wet signature</p>
                </div>
            )}
        </>
    );
};

export default PreappChildStatusBar;
